export default __webpack_public_path__ + "static/media/254.197fa686.png";